<template>
  <div class="lista-planos mt-4 mb-4">
    <lazy-load-page v-if="state.main === state.load"></lazy-load-page>
    <error-content-page
      @handleButton="findPlans"
      v-if="state.main === state.error"
    ></error-content-page>
    <empty-content-page v-if="state.main === state.empty"></empty-content-page>
    <div v-if="state.main === state.content">
      <h1
        class="font-weight-bolder md-display-2 text-center md-headline mt-5 mb-4 text-primary"
      >
        {{ residencial ? "Para sua Residência" : "Para seu Negócio" }}
      </h1>
      <div class="w-100" v-for="(content, idx) in plans" :key="idx">
        <infra-divider>
          {{ content.infraestrutura }}
        </infra-divider>

        <div class="container-fluid">
          <div class="row">
            <div class="col-12 d-flex justify-content-center align-items-lg-center flex-column">
              <h1  style="text-align: center; line-height: 1em; font-size: 4em;">Entre em contato e se surpreenda!</h1>
              <h1  style="text-align: center; font-size: 2em;">0800 089 0089</h1>
              <h1  style="text-align: center; font-size: 1.5em;">Todos os dias do ano de 08h às 22h</h1>
            </div>
          </div>
        </div>


        <!-- <div class="container">
          <div class="row">
            <div
              v-for="(plan, idx) in content.plans"
              :key="`P${idx}`"
              :class="plan.class"
            >
              <card-plan
                :titulo="plan.titulo"
                :velocidade="plan.velocidade"
                :franquia="plan.franquia"
                :valor="plan.valor"f
                @handleButton="createDialog(plan)"
              ></card-plan>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>{{ plan.titulo }}</md-dialog-title>
      <md-dialog-content>
        <h3 class="md-subheading m-0 text-primary">
          Entre em contato com a VirteX para mais informações.
        </h3>
        <md-list class="m-0">
          <md-list-item v-for="tel in sharedState.cityInfo.pabx" :key="tel">
            <md-icon class="md-primary">phone</md-icon>
            <span class="md-list-item-text">{{ tel }}</span>
          </md-list-item>
          <md-divider class="md-inset"></md-divider>
          <md-list-item>
            <md-icon class="md-primary socicon-telegram"></md-icon>
            <span class="md-list-item-text">{{
              sharedState.cityInfo.telegram.num
            }}</span>
            <md-button
              :href="`https://telegram.me/${sharedState.cityInfo.telegram.id}`"
              target="_blank"
              class="md-icon-button md-list-action"
            >
              <md-icon class="md-primary">chat_bubble</md-icon>
            </md-button>
          </md-list-item>
        </md-list>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false"
          >Fechar</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import getPlans from "../scripts/getPlans";
import planListFiltredToPlanWithClass from "../scripts/planListFiltredToPlanWithClass";
import planGroupBlock from "../scripts/planGroupBlock";
import CardPlan from "../components/CardPlan";
import LazyLoadPage from "../components/LazyLoadPage";
import ErrorContentPage from "../components/ErrorContentPage";
import EmptyContentPage from "../components/EmptyContentPage";
import ContainerBlockPlan from "../components/ContainerBlockPlan";
import InfraDivider from "./InfraDivider";

export default {
  name: "ListaPlanos",
  components: {
    InfraDivider,
    EmptyContentPage,
    ErrorContentPage,
    LazyLoadPage
  },
  data() {
    return {
      plans: [],
      plan: {},
      state: {
        main: 0,
        load: 0,
        error: 1,
        empty: 2,
        content: 3
      },
      showDialog: false,
      sharedState: this.$store.state
    };
  },
  methods: {
    findPlans() {
      let genero = this.residencial ? "residencial" : "empresarial";
      let cidade = this.$route.params.cidade;

      let { state } = this;

      this.state.main = state.load;

      let gp = getPlans(cidade, genero);

      gp.then(content => {
        content = planListFiltredToPlanWithClass(content);

        if (content.length === 0) {
          this.state.main = state.empty;
          return;
        }

        // content = planGroupBlock(content);

        this.state.main = state.content;
        this.plans = content;
      });

      gp.catch(() => {
        this.state.main = state.error;
      });
    },
    createDialog(plan) {
      this.showDialog = true;
      this.plan = plan;
    }
  },
  created() {
    this.findPlans();
  },
  props: {
    residencial: { default: false },
    empresarial: { default: false }
  }
};
</script>

<style scoped>
</style>
